import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "error-message" }
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "An error occurred!")
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Unfortunately Wikipedia doesn't provide this information for days before ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("July 2nd, 2015")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_8 = { key: 2 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.errorType === 'no-information-for-today')
      ? (_openBlock(), _createBlock("p", _hoisted_3, " Wikipedia doesn't give access to the top pages before the end of the day. Past dates should be fine though. "))
      : (_ctx.errorType === 'no-information-before-2015')
        ? (_openBlock(), _createBlock("p", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, { to: { name: 'exact-date', params: { date: '2015-07-02' } } }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _hoisted_7
          ]))
        : (_ctx.errorType === 'general-problem')
          ? (_openBlock(), _createBlock("p", _hoisted_8, " This might be because the page hit Wikipedia's rate limit. Try again later. "))
          : _createCommentVNode("", true)
  ]))
}